import React from "react";
import { Box } from "@mui/material";
// import CallIcon1 from "../assets/callIcon.svg";
import { ReactComponent as CallIcon } from "../assets/callIconcopy.svg";
import { callRedirectionNo } from "../api/Redirection";
const CallFloatingIcon = () => {
  const handleCallClick = () => {
    window.open(callRedirectionNo); // Replace with your phone number
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: "160px", sm: "30px" },
        height: { xs: "30px", sm: "60px" },
        width: { xs: "30px", sm: "60px" },
        right: { xs: "0", sm: "80px" },
        display: { xs: "flex", sm: "none" },
        justifyContent: "center",
        alignItems: "center",
        background: "#F7EEE6",

        transition: "background-color 0.3s ease",
        cursor: "pointer",

        borderTopRightRadius: { xs: "0", sm: "50%" }, // Right top
        borderBottomRightRadius: { xs: "0", sm: "50%" }, // Right bottom
        borderTopLeftRadius: { xs: "50%", sm: "0" }, // Left top
        borderBottomLeftRadius: { xs: "50%", sm: "0" }, // Left bottom
        padding: { xs: "7px", sm: "5px" },
        zIndex: 3,
        "&:hover": {
          backgroundColor: "#F7EEE6",
        },
      }}
      onClick={handleCallClick}
    >
      <CallIcon
        sx={{ fontSize: { xs: "30px", sm: "50px" }, color: "#B8772A" }}
      />
    </Box>
  );
};

export default CallFloatingIcon;
